export const MAX_ROWS = 2;
export const MIN_TILE_SIZE = 128;
export const COLUMN_GAP = 16;
export const ROW_GAP = 18;

type TileFit = {
  capacity: number;
  columns: number;
  /** More tiles than MAX_ROWS rows hold, so files collapse into a "+N" tile. */
  grouped: boolean;
};

export function fitTiles({
  tileCount,
  width,
}: {
  tileCount: number;
  width: number;
}): TileFit {
  const columns = Math.max(
    1,
    Math.floor((width + COLUMN_GAP) / (MIN_TILE_SIZE + COLUMN_GAP)),
  );
  const capacity = columns * MAX_ROWS;

  return { capacity, columns, grouped: tileCount > capacity };
}
